import { BANNER_HEIGHT, TOP_BAR_HEIGHT } from '@ucc/unified-admin-common'

interface CalculateMarginParams {
  bannerMargin: boolean
  isIntercomBannerShowing: boolean
}
export const calculateMargin = ({ isIntercomBannerShowing, bannerMargin }: CalculateMarginParams) => {
  if (isIntercomBannerShowing) return '0'
  let margin = TOP_BAR_HEIGHT
  if (bannerMargin) margin += BANNER_HEIGHT
  return `${margin}px`
}

interface CalculateBannerHeightParams {
  bannerMargin: boolean
}
export const calculateBannerHeight = ({ bannerMargin }: CalculateBannerHeightParams) => {
  let margin = TOP_BAR_HEIGHT
  if (bannerMargin) margin += BANNER_HEIGHT
  return margin
}
